export const SW_VERSION = "5153661920f71808ff47f4f5697311f9";